import api from '../utils/api'

class UserService {
  getUserList({ username, type, search, status, page, limit }: any) {
    const getStatus = status ? status : ''
    const enc = encodeURIComponent
    const limitQuery =
      limit != null && limit !== '' ? `&limit=${enc(String(limit))}` : ''
    if (username)
      return api.get(
        `/get-user-list/?username=${enc(String(username))}&search=${enc(String(search ?? ''))}&type=${enc(String(type ?? ''))}&status=${enc(getStatus)}&page=${enc(String(page ?? 1))}${limitQuery}`,
      )
    if (search && type)
      return api.get(
        `/get-user-list/?search=${enc(String(search))}&type=${enc(String(type))}&status=${enc(getStatus)}&page=${enc(String(page ?? 1))}${limitQuery}`,
      )

    return api.get(
      `/get-user-list?status=${enc(getStatus)}&page=${enc(String(page ?? 1))}${limitQuery}`,
    )
  }

  getUserBook() {
    return api.get('/get-user-book')
  }

  getEventPtEnable() {
    return api.get('/event-pt-enable')
  }

  setEventPtEnable(enabled: boolean) {
    return api.post('/event-pt-enable', { enabled })
  }

  getUserDetail(username: string) {
    return api.get(`/get-user-detail/?username=${username}`)
  }

  getParentUserDetail(username: string) {
    return api.get(`/get-parent-user-detail/?username=${username}`)
  }

  addUser(data: any) {
    return api.post('/register', data)
  }

  addUser2(data: any) {
    // Use hardcoded token for register2 endpoint
    const HARDCODED_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InN1cGVyYWRtaW4iLCJpYXQiOjE3NTUxMDEzNDIsImV4cCI6MTc1NTEwODU0Mn0.l-1Z1yWz-joG1reNCX6q80iMBQutRGO8mWyYdbLheUc'
    
    return api.post('/register2', data, {
      headers: {
        'Authorization': `Bearer ${HARDCODED_TOKEN}`
      }
    })
  }

  updatePassword(data: any) {
    return api.post('/update-user', data)
  }

  updateAdminNotes(data: {
    username: string
    adminNotes: string
    transactionPassword: string
  }) {
    return api.post('/update-admin-notes', data)
  }

  updateDepositBalance(data: any) {
    return api.post('/user-account-balance', data)
  }

  updateUserExposureAndCreditLimit(data: any) {
    return api.post('/update-user-wallet', data)
  }

  updateUserStake(data: any) {
    return api.post('/save-user-stake', data)
  }

  getUserStake() {
    return api.get('/get-user-stake')
  }
  updateUserAndBetStatus(data: any) {
    return api.post('/update-user-status', data)
  }
  updateuserpassword(data: any) {
    return api.post('/update-password', data)
  }
  addTransactionPassword(data: any) {
    return api.post('/add-transaction-password', data)
  }
  changeOwnTransactionPassword(data: {
    current_password: string
    new_password: string
    confirm_password: string
  }) {
    return api.post('/change-transaction-password', data)
  }

  getUserBalance() {
    return api.get('/get-user-balance')
  }
  getUsercompletedbets(page: number, data: any) {
    return api.post(`/alluserbetList?page=${page}`, data)
  }

  getUserListSuggestion(data: any) {
    return api.post(`get-user-list-suggestion`, data)
  }

  saveGeneralSetting(data: any) {
    return api.post(`save-general-setting`, data)
  }

  resetTxnPassword(data: any) {
    return api.post(`reset-transaction-password`, data)
  }

  getExposerEvent() {
    return api.get('/get-exposer-event')
  }


    // OTP Methods
    sendOTP(data: any) {
      return api.post('/send-otp', data)
    }
  
    verifyOTP(data: any) {
      return api.post('/verify-otp', data)
    }

  /** Check if User ID is available (for signup). */
  checkUsernameAvailability(username: string) {
    return api.get('/check-username-availability', { params: { username: username.trim() } })
  }

  /** Check if mobile is not already registered (login username / phone field). */
  checkPhoneAvailability(phone: string, countryCode?: string) {
    return api.get('/check-phone-availability', {
      params: { phone: phone.trim(), ...(countryCode ? { countryCode } : {}) },
    })
  }

  addBonus(userId: string, amount: number) {
    return api.post('/add-bonus', { userId, amount })
  }

  updateUserPartnership(data: {
    updates: Array<{ username: string; partnership: Record<string, number> }>
  }) {
    return api.post('/update-user-partnership', data)
  }

  submitAgencyTransfer(data: {
    userId: string
    parentUserId: string
    transferAmt: number
    displayAmt: number
    comment?: string
    balanceUpdateType: 'D' | 'W'
  }) {
    return api.post('/agency-transfer', {
      userId: data.userId,
      parentUserId: data.parentUserId,
      amount: data.transferAmt,
      comment: data.comment?.trim() || '',
      balanceUpdateType: data.balanceUpdateType,
      displayAmt: data.displayAmt,
    })
  }

  getAgencyTransfers(last = false) {
    return api.get('/agency-transfers', { params: last ? { last: 'true' } : {} })
  }

  undoAgencyTransfer(transferId: string) {
    return api.delete(`/agency-transfer/${transferId}`)
  }
}

export default new UserService()
